import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog } from 'Models'
import { MerchantBranchModel } from 'Pages/orders'

type MerchantBranchesState = {
	all: ResponseCatalog<MerchantBranchModel>
	one: MerchantBranchModel | null
	params: RequestParams
	formState: {
		open: boolean
		item?: MerchantBranchModel
	}
}

const initialState: MerchantBranchesState = {
	all: new ResponseCatalog(),
	one: null,
	params: new RequestParams(),
	formState: {
		open: false,
		item: undefined,
	},
}

export namespace MerchantBranchesNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
	}>
	export type SetAll = PayloadAction<ResponseCatalog<MerchantBranchModel>>
	export type ClearAll = PayloadAction
	export type SetParams = PayloadAction<{ params: RequestParams }>
	export type CreateOne = PayloadAction<MerchantBranchModel>
	export type UpdateOne = PayloadAction<{
		data: MerchantBranchModel
		id: number
	}>
	export type DeleteOne = PayloadAction<number>
	export type RestoreOne = PayloadAction<number>
	export type GetOne = PayloadAction<number>
	export type SetOne = PayloadAction<MerchantBranchModel>
	export type GetReport = PayloadAction
	export type OpenForm = PayloadAction<{ item?: MerchantBranchModel }>
	export type CloseForm = PayloadAction
}

export const merchantBranchesSlice = createSlice({
	name: 'merchantBranches',
	initialState,
	reducers: {
		getAll: (state, action: MerchantBranchesNS.GetAll) => {},
		setAll: (state, action: MerchantBranchesNS.SetAll) => {
			state.all = action.payload
		},
		clearAll: (state, action: MerchantBranchesNS.ClearAll) => {
			state.all = new ResponseCatalog()
			state.params = new RequestParams()
		},
		setParams: (state, action: MerchantBranchesNS.SetParams) => {
			state.params = action.payload.params
		},
		createOne: (state, action: MerchantBranchesNS.CreateOne) => {},
		updateOne: (state, action: MerchantBranchesNS.UpdateOne) => {},
		deleteOne: (state, action: MerchantBranchesNS.DeleteOne) => {},
		restoreOne: (state, action: MerchantBranchesNS.RestoreOne) => {},
		getOne: (state, action: MerchantBranchesNS.RestoreOne) => {},
		setOne: (state, action: MerchantBranchesNS.SetOne) => {
			state.one = action.payload
		},
		getReport: (state, action: MerchantBranchesNS.GetReport) => {},
		openForm: (state, action: MerchantBranchesNS.OpenForm) => {
			state.formState = {
				open: true,
				item: action.payload.item,
			}
		},
		closeForm: (state, action: MerchantBranchesNS.CloseForm) => {
			state.formState = initialState.formState
		},
	},
})
